var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "580px",
    height: "580px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "nonzero",
    clipRule: "nonzero",
    viewBox: "0 0 5800 5800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sign_warning icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "sign_warning icon from the IconExperience.com I-Collection. Copyright by INCORS GmbH (www.incors.com).")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "curve28",
    fill: "#000000",
    d: "M2800 4500l200 0 0 200 -200 0 0 -200zm200 -2400l0 2000 -200 0 0 -2000 200 0zm63 -1327c-34,-60 -94,-94 -163,-94 -69,0 -129,34 -163,94l-2308 4053c-34,58 -39,128 -5,187 38,67 102,87 176,87l4633 2c62,0 116,-27 147,-83 33,-61 26,-134 -9,-193l-2308 -4053zm173 -98l2308 4051c148,255 -7,575 -311,575l-4652 -1c-300,1 -474,-317 -325,-574l2308 -4051c150,-264 525,-258 672,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignWarning);
export default __webpack_public_path__ + "static/media/sign_warning.0d584c3c52176b460feba62ec1467735.svg";
export { ForwardRef as ReactComponent };